import React from 'react';
import { useLocation, useOutletContext } from 'react-router-dom';
import { FaCheck, FaTimes } from 'react-icons/fa';


const ReportDetails = () => {
    const location = useLocation();
    const { event, mcq_responses, programming_responses, category_wise, consolidated_marks } = location.state.data;
    const { candidateId, candidateName } = location.state;
    const { setCustomTitle } = useOutletContext() || {};

    React.useEffect(() => {
        if (event?.event_name && setCustomTitle) {
            setCustomTitle(event.event_name);
        }
    }, [event?.event_name, setCustomTitle]);

    return (
        <div className="flex flex-col min-h-screen bg-campus-bg">
            {/* Main Content */}
            <main className="flex-grow p-8">
                {/* Event Details */}
                <div className="bg-campus-surface shadow-card rounded-card border border-campus-border p-6 mb-6">
                    <h2 className="text-2xl font-heading font-semibold mb-3 text-campus-text-primary">{event.event_name}</h2>
                    <div className="flex flex-col gap-1">
                        <p className="text-sm font-semibold text-campus-text-primary">Candidate ID: <span className="font-normal text-campus-text-body">{candidateId}</span></p>
                        <p className="text-sm font-semibold text-campus-text-primary">Candidate Name: <span className="font-normal text-campus-text-body">{candidateName}</span></p>
                    </div>
                    <p className="text-campus-text-body text-sm mt-2">Date: {new Date(event.event_date).toLocaleDateString()}</p>
                </div>

                {/* MCQ Responses */}
                <div className="mb-8">
                    <h3 className="text-xl font-heading font-semibold mb-4 text-campus-text-primary">MCQ Responses</h3>
                    <div className="space-y-4">
                        {mcq_responses.map((mcq, index) => (
                            <div key={mcq.question_id} className="flex items-start gap-4 border-b border-campus-border pb-2">
                                <span className="font-medium text-campus-text-primary">{index + 1}.</span>
                                <div className="flex-grow">
                                    <p className="text-campus-text-body">{mcq.question_text}</p>
                                </div>
                                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                                    {mcq.is_correct ? (
                                        <FaCheck className="text-campus-success" size={16} />
                                    ) : (
                                        <FaTimes className="text-campus-error" size={16} />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Programming Responses */}
                <div className="mb-8">
                    <h3 className="text-xl font-heading font-semibold mb-4 text-campus-text-primary">Programming Responses</h3>
                    {programming_responses.map((prog) => (
                        <div key={prog.question_id} className="space-y-3">
                            <p className="font-medium text-campus-text-primary">{prog.question_text}</p>
                            <div className="bg-campus-bg p-4 rounded-xl border border-campus-border">
                                <h4 className="text-sm font-semibold mb-2 text-campus-text-primary">Submitted Code:</h4>
                                <pre className="bg-campus-text-primary text-white p-4 rounded-lg overflow-x-auto text-sm">
                                    <code>{prog.submitted_code}</code>
                                </pre>
                            </div>
                            <div className="bg-campus-bg p-4 rounded-xl border border-campus-border">
                                <h4 className="text-sm font-semibold mb-2 text-campus-text-primary">Compilation Message:</h4>
                                <p className="text-campus-text-body">{prog.compilation_message}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Category-wise Results */}
                <div className="mb-8">
                    <h3 className="text-xl font-heading font-semibold mb-4 text-campus-text-primary">Category-wise Results</h3>
                    <div className="space-y-3">
                        {category_wise.map((category) => (
                            <div key={category.question_category} className="flex justify-between items-center bg-campus-surface p-4 rounded-xl border border-campus-border shadow-card">
                                <p className="font-medium text-campus-text-primary">{category.question_category}</p>
                                <p className="text-sm font-semibold text-campus-text-body">{category.correct_answers} / {category.total_attempted}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Consolidated Marks */}
                <div>
                    <h3 className="text-xl font-heading font-semibold mb-4 text-campus-text-primary">Results Summary</h3>
                    <div className="space-y-3">
                        <div className="flex justify-between items-center bg-campus-surface p-4 rounded-xl border border-campus-border shadow-card">
                            <p className="font-medium text-campus-text-primary">MCQ Score</p>
                            <p className="text-sm font-semibold text-campus-text-body">{consolidated_marks.total_mcq_correct} / {consolidated_marks.total_mcq_attempted}</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ReportDetails;
